// src/pages/hr/HRCompliance.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRCompliance() {
  return (
    <HRComingSoon
      icon="🛡️"
      title="Compliance & Governance"
      description="Manage statutory compliance, company policy documents, employee acknowledgment tracking, document expiry tracker, labor law checklists, and system audit logs. Coming soon."
    />
  );
}
